import React, { useEffect, useState, memo } from "react";
import FlashCoachLogo from "../../components/_Icons/FlashCoachLogo";

import { useHistory, useParams } from "react-router-dom";

import { getLocalValue } from "../../utils/auth";
import { DashboardLayoutWithoutSidebar } from "../../layouts/DashboardLayoutWithoutSidebar";
import { RequestFrom } from "./RequestFrom";
import styles from "./HelpRequestForm.module.scss";

export const HelpRequestStart = memo(() => {
  const [country, setCountry] = useState("");
  const [accessKey, setAccessKey] = useState("");
  const [employeeId, setEmployeeId] = useState(
    getLocalValue("employee_id") ?? ""
  );

  const history = useHistory();
  const { key } = useParams();

  //check for valid key in url parameter and then only render the page
  useEffect(() => {
    if (sessionStorage.getItem("HRF_EMP_INFO")) {
      const empInfo = JSON.parse(sessionStorage.getItem("HRF_EMP_INFO"));

      if (key !== empInfo.TOKEN.split(".")[0]) {
        history.replace("/");
      } else {
        console.log("You are authorized for the session!");
        setCountry(empInfo.COUNTRY_NAME);
        setAccessKey(key);
      }
    } else {
      const accessToken = getLocalValue("access_token");
      if (accessToken && accessToken !== "") {
        console.log("You are authorized with loggedin!");
        setCountry(getLocalValue("region"));
        setAccessKey(accessToken.split(".")[0]);
      } else {
        history.replace("/");
      }
    }
  }, [key, history]);

  return employeeId && employeeId !== "" ? (
    <DashboardLayoutWithoutSidebar>
      <RequestFrom country={country} akey={accessKey} employeeId={employeeId} />
    </DashboardLayoutWithoutSidebar>
  ) : (
    <div className={styles.pageWrapper}>
      <div className={styles.topNavbar}>
        <div className={styles.navbarContainer}>
          <div style={{ width: "160px" }}>
            <FlashCoachLogo />
          </div>
        </div>
      </div>
      <RequestFrom country={country} akey={accessKey} employeeId={employeeId} />
    </div>
  );
});
